module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-15.11365077.png";